import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { Subscription } from 'rxjs';
import { LottosService } from '../../services/lottos/lottos.service';

@Component({
  selector: 'app-countdown',
  templateUrl: './countdown.component' + AuthService.multisite.view + '.html',
  styleUrls: ['./countdown.component.scss']
})
export class CountdownComponent implements OnInit {
  public draw: string;
  public d: number;
  public h: number;
  public m: number;
  public s: number;
  public subs: Subscription;
  constructor(protected lotto: LottosService) {}

  ngOnInit(): void {
    this.setCountDown();
  }

  setCountDown() {
    this.subs = this.lotto.lottoObservable$.subscribe((lottoObj) => {
      this.draw = lottoObj['draw'];

      this.countDown();
    });
  }

  countDown() {
    let _time: any = this.draw.split(/[- :]/);
    let _date: any = new Date(_time[0], _time[1] - 1, _time[2], _time[3], _time[4], _time[5]);
    let countDownDate: any = new Date(_date).getTime();
    const x = setInterval(() => {
      let now: any = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles' })).getTime(),
        distance: any = countDownDate - now;

      this.d = Math.floor(distance / (1000 * 60 * 60 * 24));
      this.h = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      this.m = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      this.s = Math.floor((distance % (1000 * 60)) / 1000);
      if (distance < 0) {
        clearInterval(x);
      }
    }, 1000);
  }
}
